<template>
  <v-app v-if="loaded" id="app" :class="`app-content ${Loader?'page-loader':''}`">
    <router-view></router-view>
  </v-app>
</template>
<script>

/* ============
 * Entry Point
 * ============
 *
 * The entry point of the application
 */
export default {
  data() {
    return {
      loaded: false,
    };
  },
  methods: {

    /** Listen for changes to localStorage on other tabs/windows.
    *   The event fired on the tabs that are not in focus.
    *   This ensures all tabs are synced in terms of its authenticated state
    */
    syncLocalStorage(event) {
      if (!event)
        return;
      if (event.key) {
        if (event.newValue) {
          localStorage.setItem(event.key, event.newValue);
          if (event.key === 'is_internal') {
            if (event.newValue === 'true') {
              this.$router.push({
                name: 'internal.employee.inventory',
              });
            } else if (event.newValue !== 'true') {
              this.$router.push({
                name: 'home.index',
              });
            }
          }
        } else if (event.oldValue && !event.newValue) {
          localStorage.removeItem(event.key);
          if (event.key === 'is_internal') {
            if (event.oldValue === 'true') {
              this.$router.push({
                name: 'internal.login',
              });
            } else if (event.oldValue !== 'true') {
              this.$router.push({
                name: 'home.index',
                query: {
                  login: true,
                },
              });
            }
          }
        }
      }
    },
  },
  computed: {
    webSocketConnected() {
      return this.$store.state.socket.socket.isConnected;
    },
    Loader() {
      return this.$store.state.master.loader;
    },
    overlayState() {
      return this.$store.state.home.overlayState;
    },
  },

  watch: {
    webSocketConnected(val) {
      if (!val)
        this.$store.dispatch('socket/connect');
    },
  },

  /**
   * Fires when the app has been mounted
   */

  mounted() {
    const store = this.$store;
    store.dispatch('auth/check');
    // Initialy connect to websocket
    store.dispatch('socket/connect');
    setInterval(() => {
      if (!this.webSocketConnected)
        this.$store.dispatch('socket/connect');
    }, 20000);
    // Henceforth, after every 1 minute, check if socket is connected; if not reconnect;
    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) { // detect it's IE11
      window.addEventListener('hashchange', function(_event) {
        const currentPath = window.location.hash.slice(1);
        if (store.state.route.path !== currentPath)
          this.router.push(currentPath);
      }, false);
    }
  },

  created() {
    window.addEventListener('load', () => {
      this.loaded = true;
    });
    window.addEventListener('storage', (e) => {
      this.syncLocalStorage(e);
    });
  },
};
</script>



// WEBPACK FOOTER //
// app.vue?c9b26c02